import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { BelfiusButton } from '../../components/custom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { mfaAuthenticate } from '../../store/login';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './Login.module.css';

interface PropsFromDispatch {
  readonly mfaAuthenticate: typeof mfaAuthenticate;
}

interface PropsFromState {
  readonly errorMessage: string;
  readonly showLoader: boolean;
  readonly verificationCode: string;
  readonly registeredMfa: boolean;
  readonly username: string;
  readonly invalidCode: boolean;
  readonly mfaQRCode: string;
}

interface State {
  readonly mfaCode: string;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class MfaAuthenticate extends React.Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
          mfaCode: ''
        };
    }

    mfaAuthenticate = () => {
      this.props.mfaAuthenticate(this.props.username, this.state.mfaCode);
    }

    public render() {
      const strings = getI18n();
      return (
        <div className={styles.containerMfa}>
          <div className={styles.mfaScreenAlignCenter}>
            <a href='http://www.zamia.be' target='_blank' rel="noreferrer"><img alt="" className={styles.mfaScreenAlignCenter} src={require('../../assets/images/login.png')} /></a>
          </div>
          {!this.props.registeredMfa && (
          <div className={styles.mfaScreenAlignCenter}>
              <div className={styles.containerMfa}>
                <div>
                  <p className={styles.textAlingCenter}>{strings.get('login.scanqrcode')}</p>
                </div>
                <div>
                  <img alt="" className={styles.logo} src={this.props.mfaQRCode}></img>
                </div>
              </div>
          </div>
          )}
          <div className={styles.mfaScreenAlignCenter}>
            <div className={styles.containerMfa}>
              <div>
                <p className={styles.textAlingCenter}>{strings.get('login.inputCode')}</p>
              </div>
              <div>
                <input
                  autoFocus
                  className={styles.mfaCode}
                  value={this.state.mfaCode}
                  placeholder={strings.get('login.mfacode')}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.setState({ ...this.state, mfaCode: event.target.value });
                  }}
                  onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                    if (event.key === 'Enter') {
                      this.mfaAuthenticate();
                    }
                  }} />
                <BelfiusButton
                  className={styles.mfaOkButton}
                  onClick={() => this.mfaAuthenticate()}
                  title={strings.get('login.mfaOk')} />
              </div>
              {this.props.registeredMfa && (
              <div>
                <p className={styles.textAlingCenterSmall}>{strings.get('login.contactZamiaForMfa')}</p>
              </div>
              )}
              <div>
              {this.props.errorMessage !== '' && <p className={styles.textAlingCenterError}>{strings.get('login.invalidVerificationCode')}</p>}
              </div>
            </div>
          </div>
        </div>
      );
    }
}

const mapStateToProps = ({ shared, login }: ApplicationState): PropsFromState => ({
    errorMessage: login.errorMessage,
    showLoader: login.showLoader,
    verificationCode: login.mfaCode,
    registeredMfa: login.registeredMfa,
    username: shared.currentUser,
    mfaQRCode: login.mfaQRCode,
    invalidCode: false
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    mfaAuthenticate: (username: string, mfaCode: string) => dispatch(mfaAuthenticate(username, mfaCode))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MfaAuthenticate);
